import { Box, Typography } from '@mui/material';

export function PracticeCountPill({ value }) {
  const safeValue = Number.isFinite(Number(value)) ? Number(value) : 0;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        minWidth: 56,
        justifyContent: 'center',
        alignItems: 'center',
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        border: '1px solid rgba(245, 158, 11, 0.35)',
        bgcolor: 'rgba(245, 158, 11, 0.04)'
      }}
    >
      <Typography sx={{ fontWeight: 700, color: '#F59E0B', fontSize: '0.875rem', lineHeight: 1, letterSpacing: 0.2 }}>
        {safeValue}
      </Typography>
    </Box>
  );
}

export function PracticeShareRing({ value }) {
  const safeValue = Math.max(0, Math.min(100, Number.isFinite(Number(value)) ? Number(value) : 0));

  return (
    <Box
      sx={{
        position: 'relative',
        width: 36,
        height: 36,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `conic-gradient(#EAB308 ${safeValue * 3.6}deg, rgba(145, 158, 171, 0.24) 0deg)`
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '50%',
          bgcolor: 'background.paper',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography sx={{ fontWeight: 700, color: 'text.primary', fontSize: '0.75rem', lineHeight: 1 }}>
          {safeValue}%
        </Typography>
      </Box>
    </Box>
  );
}
